export const defaultAggregatePercentageModel = () => [
  {
    range: '81%-100%',
    I: 0,
    O: 0,
    OrgMidPoint: null,
    IndMidPoint: null,
    UnitAggregatePercentage: null,
    IndustryMddapOrgUnits: [],
    OrgMddapOrgUnits: []
  },
  {
    range: '61%-80%',
    I: 0,
    O: 0,
    OrgMidPoint: null,
    IndMidPoint: null,
    UnitAggregatePercentage: null,
    IndustryMddapOrgUnits: [],
    OrgMddapOrgUnits: []
  },
  {
    range: '41%-60%',
    I: 0,
    O: 0,
    OrgMidPoint: null,
    IndMidPoint: null,
    UnitAggregatePercentage: null,
    IndustryMddapOrgUnits: [],
    OrgMddapOrgUnits: []
  },
  {
    range: '21%-40%',
    I: 0,
    O: 0,
    OrgMidPoint: null,
    IndMidPoint: null,
    UnitAggregatePercentage: null,
    IndustryMddapOrgUnits: [],
    OrgMddapOrgUnits: []
  },
  {
    range: '0%-20%',
    I: 0,
    O: 0,
    OrgMidPoint: null,
    IndMidPoint: null,
    UnitAggregatePercentage: null,
    IndustryMddapOrgUnits: [],
    OrgMddapOrgUnits: []
  }
];
